/* eslint-disable react-refresh/only-export-components -- False positive for use right now. No iimediate need to split. https://github.com/ArnaudBarre/eslint-plugin-react-refresh/issues/22*/
import { createContext, useContext, useEffect, useState } from 'react';
import BackendApi from '../../api/backendApi';
import { getConfig } from '../../config/envconfig';
import { AuthContext } from './AuthenticationContext';

type BackendApiContextType = {
    backendApi: BackendApi | undefined;
};
export const BackendApiContext = createContext<BackendApiContextType>({
    backendApi: undefined
});

type BackendApiContextProviderProps = {
    children: React.JSX.Element;
};

export const BackendApiContextProvider = ({
    children
}: BackendApiContextProviderProps) => {
    const [backendApi, setBackendApi] = useState<BackendApiContextType>({
        backendApi: undefined
    });
    const { user, isAuthenticated } = useContext(AuthContext);

    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }
        if (!user?.access_token) {
            return;
        }
        const bffApiUrl = getConfig().bff_api_url;
        if (!bffApiUrl) {
            return;
        }
        setBackendApi({
            backendApi: new BackendApi(bffApiUrl, user.access_token)
        });
    }, [isAuthenticated, user]);

    return (
        <BackendApiContext.Provider value={backendApi}>
            {children}
        </BackendApiContext.Provider>
    );
};
